"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardDataAreaMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _spacingMixin = require("../spacingMixin");
var _truncationMixin = require("../truncationMixin");
var _typographyMixin = require("../typographyMixin");
/** @class PropertyCardDataAreaMixin */
/** @method */
var PropertyCardDataAreaMixin = function PropertyCardDataAreaMixin(props) {
  var appearance = props.appearance,
    dataType = props.dataType,
    lineClamp = props.lineClamp;
  return (0, _styledToken.default)({
    fontType: "PropertyCard.data." + dataType + ".fontType" + (dataType === 'title' ? "." + appearance : ''),
    fontColor: "PropertyCard.data." + dataType + ".fontColor",
    fontFamily: "PropertyCard.data." + dataType + ".fontFamily"
  }, function (_ref) {
    var fontColor = _ref.fontColor,
      fontType = _ref.fontType,
      fontFamily = _ref.fontFamily;
    return (0, _styledComponents.css)(["grid-area:", ";color:", ";address{font-style:normal;}", " ", " ", ""], dataType, fontColor, lineClamp && (0, _truncationMixin.truncationMixin)(lineClamp), (0, _typographyMixin.typographyMixin)(Object.assign({
      fontType: fontType,
      fontColor: fontColor,
      fontFamily: fontFamily
    }, props)), (0, _spacingMixin.spacingMixin)(props));
  })(props);
};
exports.PropertyCardDataAreaMixin = PropertyCardDataAreaMixin;